// extracted by mini-css-extract-plugin
export default {"left":"aD5Kt","external":"bD5Kt","center":"cD5Kt","right":"dD5Kt"};